module.exports = __webpack_public_path__ + "static/media/small-white-spades.d05df4e6.svg";